'use strict';

class OrderConfirmationView {
  constructor($routeParams, $location, orderConfirmationService, originatorService) {
    this.$location = $location;
    this.orderConfirmationService = orderConfirmationService;
    this.originatorService = originatorService;
    this.orderConfirmationNumber = $routeParams.number;
  }

  $onInit() {
    this.orderConfirmation = {};
    this.info = {};
    this.related = {};

    this.load();
  }

  load() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });

    this.orderConfirmationService.getOrderConfirmation(this.orderConfirmationNumber)
      .then((resp) => {
        this.orderConfirmation = resp.data;
      });

    this.orderConfirmationService.getViewInfo(this.orderConfirmationNumber)
      .then((resp) => {
        this.info = resp.data;
        this.related = resp.data.relatedTo;
      });
  }

  cancel() {
    this.orderConfirmationService.cancelDocument(this.orderConfirmationNumber)
      .then(() => this.$location.path('/ordrebekreftelse'));
  }
}

OrderConfirmationView.$inject = ['$routeParams', '$location', 'orderConfirmationService', 'originatorService'];

const orderConfirmationView = {
  controller: OrderConfirmationView,
  templateUrl: 'order-confirmation/view.html'
};

angular
  .module('SendRegning')
  .component('orderConfirmationView', orderConfirmationView)
  .config(($routeProvider) => {
    $routeProvider
      .when('/ordrebekreftelse/:number', {
        title: 'Vis ordrebekreftelse',
        template: '<order-confirmation-view />',
        secure: true
      });
  });
